import React from 'react';
import { Reorder } from 'motion/react';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { settingsFunctions } from '../../../../functions/settings';
import { useAuth } from '../../../../utils/Auth';
import Button from './Button';
import styles from './BottomCard.module.css';

function BottomCard(props) {
    const { accountType, profile_theme, messaging, buttons, buttonsState, setButtonsState, setButtonToEdit, setShowForm, permissions, uid } = props;
    const { updateVcardObject, buttonsActiveState, getSocialUserHandle } = settingsFunctions;
    const { getUpdatedUserVcard } = useAuth();

    // ------------------ Edit Button -------------------//
    const editButton = (e, btn) => {
        e.preventDefault();
        setButtonToEdit(btn);
        setShowForm('edit-button');
    };

    //------------------- Drag and Drop -----------------//
    
    const handleUpdate = async () => {
        if (JSON.stringify(buttons) !== JSON.stringify(buttonsState)) {
            const userEdit = {
                buttons: accountType === 'basic' ? buttonsActiveState(buttonsState) : buttonsState
            };

            try {
                await updateVcardObject(userEdit, uid);
                await getUpdatedUserVcard();
            } catch (err) {
                console.log(err);
            };
        }
    };

    //---------------- End Drag and Drop ----------------//
    
    if (profile_theme !== undefined) {
        return (
            <>
            <div className={styles.card} style={{background: profile_theme.btm_card_color, fontFamily: profile_theme.font}}>
                <div className={styles.topBtns}>
                    <div className={styles.downloadBtn} id='download-contact' disabled style={{background: profile_theme.btn_color, color: profile_theme.btm_text_color, borderColor: profile_theme.btm_text_color }}>
                        <i className='far fa-arrow-circle-down' aria-hidden='true'></i>
                        {window.innerWidth <= 768 ? 
                            "Download"
                            :
                            "Download Contact"
                        }
                    </div>
                    {messaging?.enabled ? <div className={styles.messageBtn} disabled style={{background: profile_theme.btn_color, color: profile_theme.btm_text_color, borderColor: profile_theme.btm_text_color}}><i className='fa fa-envelope' aria-hidden='true'></i></div> : <></>}
                </div>
                {(buttonsState && buttonsState?.length > 0) ?
                    <div className={styles.bottomBtns}>
                        <Reorder.Group axis='y' onReorder={setButtonsState} values={buttonsState}>
                            {buttonsState.map((button, i) => (
                                <Button key={button.added} button={button} editButton={editButton} permissions={permissions} profile_theme={profile_theme} handleUpdate={handleUpdate} />
                            ))}
                        </Reorder.Group>
                        {permissions.edit_button ?
                            <button className={`${styles.button} ${styles.bottomBtnAdd}`} onClick={(e) => {e.preventDefault(); setShowForm('add-button')}} style={{fontFamily: "'franklin_gothic_bookregular', sans-serif"}}>
                                <div className={styles.icons}>
                                </div>
                                <div className={styles.links}> 
                                    <h4 className={styles.linkName}>Add a Button <i className='fas fa-plus' /></h4>
                                </div>
                                <div className={styles.arrow}>
                                </div>
                            </button>
                            :
                            <></>
                        }
                    </div>
                    : 
                        <>
                        {permissions.edit_button ?
                            <button className={`${styles.bottomBtn} ${styles.bottomBtnAdd}`} onClick={(e) => {e.preventDefault(); setShowForm('add-button')}} style={{fontFamily: "'franklin_gothic_bookregular', sans-serif"}}>
                                <div className={styles.icons}>
                                </div>
                                <div className={styles.links}> 
                                    <h4 className={styles.linkName}>Add a Button <i className='fas fa-plus' /></h4>
                                </div>
                                <div className={styles.arrow}>
                                </div>
                            </button>
                            :
                            <></>
                        }
                        </>
                }
            </div>
            {(accountType === 'basic' && buttonsState?.length > 5) &&
                <OverlayTrigger
                    placement='top'
                    trigger={['hover','click']}
                    delay={{show: 0, hide: 3000}}
                    overlay={<Tooltip className='theme-builder-top'>Basic plans are limited to 5 buttons. Upgrade to <a href='/upgrade' style={{fontWeight: 'bold', color: '#fff'}}>Pro</a> to utilize all of your buttons!</Tooltip>}
                >
                    <div className={styles.basicInfo}>
                        <i className='far fa-circle-info' />
                        <p className='mb-0'>Why don't all of my buttons show on my Digital Business Card?</p>
                    </div>
                </OverlayTrigger>
            }
            </>
        );
    } else {
        <></>
    }
};

export default BottomCard;